<template>
  <div>
    <base-card v-if="areSubscriptionsLoading">
      <base-skeleton-loader class="tw-h-4 tw-w-48 tw-mt-2" />
      <base-table loading :fields="fields" class="tw-mt-4">
        <template #loading-cell>
          <base-skeleton-loader class="tw-h-3 tw-my-1.5 tw-w-10" />
        </template>
      </base-table>
      <div class="tw-mt-6 tw-pt-2.5 tw-px-4 sm:tw-pt-4 sm:tw-px-6 tw--mx-4 sm:tw--mx-6 tw-border-t tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 tw-gap-2">
        <div v-for="i in 2" :key="i">
          <base-skeleton-loader class="tw-h-2 tw-w-10 tw-mt-1" />
          <base-skeleton-loader class="tw-h-3 tw-mt-3 tw-mb-1 tw-w-32" />
        </div>
      </div>
    </base-card>
    <div v-else-if="subscriptions.length">
      <base-card v-for="subscription in subscriptions" :key="subscription.subscriptionId">
        <div v-for="item in subscription.items" :key="item.itemId">
          <h3 class="tw-text-xl tw-font-thin tw-mb-0">{{ item.productName }}</h3>
          <base-table :fields="fields" :items="item.tiers" class="tw-mt-3">
            <template #memberPlans="{ item: memberPlan }">
              <div class="tw-flex tw-items-center">
                Up to
                <span v-if="memberPlan.upTo">&nbsp;{{ memberPlan.upTo }}</span>
                <infinity-icon class="tw-h-6 tw-ml-1" v-else />
              </div>
            </template>
            <template #unitPrice="{ item: unitPrice }">
              <div class="tw-flex">
                <MoneyFormat :value="unitPrice.unitAmount || unitPrice.flatAmount" :locale="locale" :currency-code="item.currency" subunits-value />&nbsp;/ plan
              </div>
            </template>
          </base-table>
        </div>
        <div class="tw-mt-6 tw-pt-2.5 tw-px-4 sm:tw-pt-4 sm:tw-px-6 tw--mx-4 sm:tw--mx-6 tw-border-t tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 tw-gap-2">
          <div>
            <div class="tw-text-gray-600 tw-text-xs tw-font-normal">Started On</div>
            <div class="">{{ customDateFormatter(subscription.createdDate) }}</div>
          </div>
          <div>
            <div class="tw-text-gray-600 tw-text-xs tw-font-normal">Current Billing Period</div>
            <div class="">{{ `${customDateFormatter(subscription.currentPeriodStartDate)} - ${customDateFormatter(subscription.currentPeriodEndDate)}` }}</div>
          </div>
        </div>
      </base-card>
    </div>
    <div class="tw-flex tw-justify-center tw-text-gray-700" v-else>
      Business has no subscriptions
    </div>
  </div>
</template>

<script>
import { InfinityIcon } from "@/assets/svgs";
import MoneyFormat from "vue-money-format";
import moment from "moment";

export default {
  components: {
    InfinityIcon,
    MoneyFormat,
  },
  props: {
    businessId: String,
    businessName: String,
  },
  data() {
    return {
      areSubscriptionsLoading: false,
      subscriptions: [],
      fields: [{ title: "Member Plans", key: "memberPlans" }, { title: "Unit Price", key: "unitPrice" }],
    };
  },
  computed: {
    locale() {
      return window.navigator.language;
    },
  },
  mounted() {
    this.getMySubscriptions();
  },
  methods: {
    async getMySubscriptions() {
      try {
        this.areSubscriptionsLoading = true;
        const response = await this.$axios.get(`/businesses/${this.businessId}/subscriptions`);
        this.subscriptions = response.data;
      } finally {
        this.areSubscriptionsLoading = false;
      }
    },
    customDateFormatter(date) {
      return moment
        .utc(date)
        .local()
        .format("MMM D, YYYY");
    },
  },
};
</script>
